module.exports = __webpack_public_path__ + "name=img/src/assets/icons/ic_facebook.svg?43ce8ac293f381f02bd5faa6ccdc6bea";